import React from "react";
import { compose, withStateHandlers, withHandlers } from "recompose";
import { Table, Button, PopoverBody } from "reactstrap";
import { Trans } from "react-i18next";
import { Link } from "react-router-dom";
import {
  AddNewButton,
  withTable,
  Page,
  withPopover,
  PendingButton,
} from "components/common";
import BackButton from "components/refactoring/BackButton";

const DeleteCell = withPopover()(
  ({ togglePopover, i, Popover, onDelete, pending }) => (
    <td className="w-100">
      {!i.is_system && (
        <React.Fragment>
          <Button
            onClick={togglePopover}
            id={`remove-${i.id}`}
            color="link"
            size="sm"
            className="text-danger p-0"
          >
            <span className="fa fa-trash" />
          </Button>
          <Popover target={`remove-${i.id}`}>
            <PopoverBody>
              <div className="d-flex flex-column">
                <Trans>
                  Are you sure you want to delete this email template?
                </Trans>
                <PendingButton
                  pending={pending}
                  size="sm"
                  color="success"
                  onClick={() => onDelete(i)}
                  className="align-self-end mt-3"
                >
                  Confirm
                </PendingButton>
              </div>
            </PopoverBody>
          </Popover>
        </React.Fragment>
      )}
    </td>
  )
);

export const EmailTemplatesList = ({
  match,
  data,
  setData,
  TableContainer,
  onDelete,
  XeroTableDataFetch,
  pending,
}) => (
  <Page title="Email Templates" className="inv-table">
    <div className="flex flex-column mb-2">
      <BackButton />
    </div>
    <AddNewButton resource="Email Template" match={match} className="mb-2" />
    <div>
    <TableContainer items={data.results}>
      <Table size="sm">
        <thead>
          <tr>
            <th className="text-nowrap text-left">
              <Trans>Type</Trans>
            </th>
            <th className="text-nowrap text-left">
              <Trans>Name</Trans>
            </th>
            <th />
          </tr>
        </thead>
        <tbody>
          {data.results.map((i) => (
            <tr key={i.id}>
              <td className="text-nowrap text-left">
                <div className="mr-3">
                  {i.type_name}{" "}
                  {i.is_default ? (
                    <span className="text-muted small">
                      <Trans>DEFAULT</Trans>
                    </span>
                  ) : null}
                </div>
              </td>
              <td className="text-nowrap text-left">
                <Link className="mr-3" to={`${match.url}/${i.id}`}>
                  {i.name}
                </Link>
              </td>
              <DeleteCell i={i} pending={pending} onDelete={onDelete} />
            </tr>
          ))}
        </tbody>
      </Table>
    </TableContainer>
    </div>
    <XeroTableDataFetch onDataFetched={setData} />
  </Page>
);

const enhance = compose(
  withStateHandlers({}, { setPending: () => (pending) => ({ pending }) }),
  withTable({ limit: 100, url: "email_templates" }),
  withHandlers({
    onDelete:
      ({ xero, setPending, refreshData }) =>
      (i) => {
        setPending(true);
        xero
          .delete(`email_templates/${i.id}`)
          .then(() => {
            refreshData();
          })
          .finally(() => setPending(false));
      },
  })
);

export default enhance(EmailTemplatesList);
